<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="container-style needs-validation" [formGroup]="formProviderInvoice" novalidate>
        <div class="ps-2 pe-1">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" (onClick)="goToBack($event)" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>
            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <app-custom-button [title]="'Eliminar'" [severity]="'contrast'" [icon]="'pi pi-trash'"
                (onClick)="deleteProviderInvoice()"></app-custom-button>
              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
                (onClick)="createNewProviderInvoice()"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col">
              <app-custom-audit-info [userNameCreate]="providerInvoiceModel.userNameCreate"
                [createDate]="providerInvoiceModel.createDate" [userNameUpdate]="providerInvoiceModel.userNameUpdate"
                [updateDate]="providerInvoiceModel.updateDate" [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <div class="row">
            <div class="col field-branch">
              <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranch"
                [required]="true" (onChangeSelect)="changeBranch($event)">
              </app-custom-select>
            </div>
            <div class="col field-consecutive">
              <app-custom-input-number formControlName="consecutive"
                [labelText]="'Consecutivo'"></app-custom-input-number>
            </div>
            <div class="col field-provider">
              <app-custom-autocomplete formControlName="providerId" [labelText]="'Proveedor'" [list]="listProvider"
                [recovery]="true" [required]="true" (onChangeSelect)="changeProvider($event)"></app-custom-autocomplete>
            </div>
            <div class="col field-prefix">
              <app-custom-input-text formControlName="prefix" [labelText]="'Prefijo'" [recovery]="true" [maxLength]="6"
                (onChangeTextOnBlur)="changePrefixInvoiceNumber()"></app-custom-input-text>
            </div>
            <div class="col field-invoice-number">
              <app-custom-input-number formControlName="invoiceNumber" [labelText]="'Número Fra.'" [recovery]="true"
                [required]="true" (onChangeNumber)="changePrefixInvoiceNumber()"></app-custom-input-number>
            </div>
            <div class="col field-change-prefix-number d-flex align-items-end">
              <div class="d-flex justify-content-center">
                <app-custom-button [label]="'Cambiar Nro.Fra'" [severity]="'success'" [width]="'8rem'"
                  (onClick)="openPrefixInvoiceNumberModal()"></app-custom-button>
                <app-custom-modal #prefixInvoiceNumberModal [label]="'Cambiar Nro.Fra'" [header]="'Cambiar Nro.Fra'"
                  [inputs$]="inputsForRetentionsModal$" [children]="componentPrefixInvoiceNumberModal" [width]="'30rem'"
                  [closable]="false" [focusShow]="false" (params)="reloadProviderInvoice($event)" hidden>
                </app-custom-modal>
              </div>
            </div>
            <div class="col field-state">
              <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateString"></app-custom-tag>
            </div>
            <div class="col field-state-button d-flex align-items-end mt-1">
              <app-custom-button [icon]="iconState" [title]="titleState" [severity]="'primary'"
                (onClick)="changeState()"></app-custom-button>
            </div>
          </div>
          <div class="row">
            <div class="col field-enterprise">
              <app-custom-select formControlName="enterpriseId" [labelText]="'Empresa'" [list]="listEnterprise"
                [required]="true"></app-custom-select>
            </div>
            <div class="col field-date">
              <app-custom-datepicker formControlName="date" [labelText]="'Fecha'" [required]="true"
                (onChangeDate)="changeDate()"></app-custom-datepicker>
            </div>
            <div class="col field-date-expiration">
              <app-custom-datepicker formControlName="dateExpiration" [labelText]="'Fecha Vencimiento'"
                [required]="true"></app-custom-datepicker>
            </div>
            <div class="col field-iva-type">
              <app-custom-select formControlName="ivaTypeId" [labelText]="'Tipo IVA'" [list]="listIvaType"
                [required]="true"></app-custom-select>
            </div>
            <div class="col field-observation">
              <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [autoResize]="false"
                [rows]="1" [maxLength]="90"></app-custom-textarea>
            </div>
            <div class="col field-save-button d-flex align-items-end justify-content-end mt-2">
              <app-custom-button [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                [disabled]="disabledForm" (onClick)="send()"></app-custom-button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="row" *ngIf="providerInvoiceId !== 0">
    <p-accordion [(value)]="activePanel" value="none" class="accordion-detail" [transitionOptions]="'0ms'"
      (onClose)="toggleAccordion()" (onOpen)="toggleAccordion()">
      <p-accordion-panel value="0">
        <p-accordion-header>
          <div class="d-flex align-items-center gap-2 w-100">
            <span class="flex-grow-1"> Detalle de la factura proveedor ({{quantityDetails}}) </span>
            <div class="mx-3 d-flex gap-2" (click)="$event.stopImmediatePropagation()"
              (mousedown)="$event.stopImmediatePropagation()">
              <!-- Detalle -->
              <app-custom-button [label]="'Art. con Entrada'" [severity]="'success'" [width]="'8rem'"
                [disabled]="disabledForm" (onClick)="openSelectArticleWithEntry()">
              </app-custom-button>
              <app-custom-modal #articleWithEntrySelection [label]="'Seleccionar'"
                [header]="'Selección de Artículos con Entrada'" [children]="componentTableSelection"
                [inputs$]="inputsForArticleWithEntrySelection$" [output$]="outputArticleWithEntry$"
                (selectedItems)="handleSelectedItems($event, sourceEnums.inventoryEntry)" hidden>
              </app-custom-modal>
              <app-custom-button [label]="'Art. con OC'" [severity]="'success'" [width]="'7rem'"
                [disabled]="disabledForm" (onClick)="openSelectArticleWithOC()">
              </app-custom-button>
              <app-custom-modal #articleWithOCSelection [label]="'Seleccionar'"
                [header]="'Selección de Artículos con OC'" [children]="componentTableSelection"
                [inputs$]="inputsForArticleWithOCSelection$" [output$]="outputArticleWithOC$"
                (selectedItems)="handleSelectedItems($event, sourceEnums.purchaseOrder)" hidden>
              </app-custom-modal>
              <app-custom-button [label]="'Art. Otros'" [severity]="'success'" [width]="'7rem'"
                [disabled]="disabledForm" (onClick)="openSelectArticleOthers()">
              </app-custom-button>
              <app-custom-modal #articleOthersSelection [label]="'Seleccionar'" [header]="'Selección de Equipos'"
                [children]="componentTableSelection" [inputs$]="inputsForArticleOthersSelection$"
                [output$]="outputArticleOthers$" (selectedItems)="handleSelectedItems($event, sourceEnums.others)"
                hidden>
              </app-custom-modal>
            </div>
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <div class="row detail-container container-detail" [hidden]="providerInvoiceModel.providerInvoiceId == 0"
            [hidden]="!showAccordion">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-provider-invoice-detail [providerInvoiceModel]="providerInvoiceModel" [isFormView]="isFormView"
                [providerInvoiceDetailModel]="providerInvoiceDetailContract" [updateListDetail]="updateListDetail"
                [disableDetail]="disabledForm" (quantityDetails)="quantityDetails = $event"
                [permissionUpdatable]="permissionUpdatable" (updateProviderInvoice)="getUpdateProviderInvoice($event)">
              </app-provider-invoice-detail>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </div>

  <!-- Valores e impuestos de la factura proveedor -->
  <form class="needs-validation container-style mt-2" [formGroup]="formProviderInvoiceFooter">
    <div class="col-lg-12 col-12">
      <div class="row d-flex justify-content-between">
        <div class="col-lg-3 col-12">
          <div class="row">
            <div class="col fields-values">
              <app-custom-input-decimal formControlName="noteDebitValue"
                [labelText]="'Nota Débito'"></app-custom-input-decimal>
            </div>
            <div class="col fields-values">
              <app-custom-input-decimal formControlName="noteCreditValue"
                [labelText]="'Nota Crédito'"></app-custom-input-decimal>
            </div>
          </div>
          <div class="row">
            <div class="col fields-values">
              <app-custom-input-decimal formControlName="paymentValue"
                [labelText]="'Abonos'"></app-custom-input-decimal>
            </div>
            <div class="col fields-values">
              <app-custom-input-decimal formControlName="residueValue" [labelText]="'Saldo'"></app-custom-input-decimal>
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-12">
          <div class="row">
            <div class="col fields-values">
              <app-custom-input-decimal formControlName="subtotalValue"
                [labelText]="'Subtotal'"></app-custom-input-decimal>
            </div>
            <div class="col fields-values">
              <app-custom-input-decimal formControlName="ivaValue" [labelText]="'Vr.Iva'"></app-custom-input-decimal>
            </div>
            <div class="col fields-values">
              <app-custom-input-decimal formControlName="totalValue" [labelText]="'Total'"></app-custom-input-decimal>
            </div>
          </div>
          <div class="row">
            <div class="col fields-values">
              <app-custom-input-decimal formControlName="retentionValue"
                [labelText]="'Vr.Retenciones'"></app-custom-input-decimal>
            </div>
            <div class="col fields-values">
              <app-custom-input-decimal formControlName="advanceValue"
                [labelText]="'Vr.Anticipo'"></app-custom-input-decimal>
            </div>
            <div class="col fields-values">
              <app-custom-input-decimal formControlName="retainedValue"
                [labelText]="'Vr.Retenido'"></app-custom-input-decimal>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-12 d-flex align-items-center justify-content-center">
          <div class="row">
            <div class="col field-total-to-pay">
              <app-custom-tag [label]="'Total a Pagar'"
                [value]="(providerInvoiceModel.subtotalValue + providerInvoiceModel.ivaValue - providerInvoiceModel.retentionValue | number:'1.2-2') + ' - ' + (providerInvoiceModel.provider?.currency?.code ?? '')"></app-custom-tag>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-12 d-flex align-items-center">
          <div class="row mt-3">
            <div class="d-flex justify-content-center">
              <app-custom-button [label]="'Impuestos'" [severity]="'success'" [width]="'6rem'"
                (onClick)="openRetentionsModal()"></app-custom-button>
              <app-custom-modal #retentionsModal [label]="'Impuestos y Retenciones'"
                [header]="'Impuestos y Retenciones'" [inputs$]="inputsForRetentionsModal$"
                [children]="componentRetentionsModal" [width]="'70rem'" [closable]="false" [focusShow]="false"
                (params)="reloadProviderInvoice($event)" hidden>
              </app-custom-modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>

<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1 text-danger"> highlight_off </span>
  <h6 class="text-danger">No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>